import { useTranslation } from 'react-i18next'

import { Form, InputFormRowProps } from 'app/common/presentation'
import { AvailableOrInstalledConnection } from 'app/connections/types'

import { Input } from 'components'

import styles from './InputWithExampleFormRow.module.scss'

export interface InputWithExampleFormRowProps extends Omit<InputFormRowProps, 'title' | 'value'> {
  data: { key: string; value: string }
  example: JSX.Element
  exampleHint: string
  handleOnChange: (value: string) => void
  connection: AvailableOrInstalledConnection
}

const InputWithExampleFormRow = ({
  data,
  example,
  exampleHint,
  handleOnChange,
  connection,
  ...inputProps
}: InputWithExampleFormRowProps) => {
  const { t } = useTranslation('connections')

  return (
    <Form.FormRow
      className={styles.row}
      contentColumnClassName={styles.contentColumn}
      description={t(`setup.${connection.name}.config.${data.key}.description`)}
      inputFieldClassName={styles.inputField}
      title={t(`setup.${connection.name}.config.${data.key}.title`)}
    >
      <Input
        className={styles.input}
        onChange={
          connection.readonly || connection.readonlyConfig.includes(data.key)
            ? undefined
            : handleOnChange
        }
        value={data.value}
        {...inputProps}
      />
      <div className={styles.example}>
        <div>{exampleHint}</div>
        {example}
      </div>
    </Form.FormRow>
  )
}

export default InputWithExampleFormRow
